import { Dispatch } from "redux"
import { camelize } from "../../config/functions"
import { getStockMaster, updateStockMaster } from "../../services/stockMaster.service"
import { AppDispatch, StoreState } from "../store"



export interface StockMasterType {
    id: number
    productId: number,
    batchNumber: number
    expiryDate: string
    brandId?: string
    categoryId?: string
    categoryName?: string
    departmentName?: string
    brandName?: string
    attribute1?: string
    attribute2?: string
    attribute3?: string
    attribute4?: string
    attribute5?: string
    quantity: number
    freeQuantity: number
    totalQuantity: number
    purchaseRate: number
    priceWogst: number
    priceGst: number
    freightCost: number
    landingCost: number
    marginPercent: number
    marginAmt: number
    salesRate: number
    wRate: number
    rRate: number
    lRate: number
    mrp: number
    taxableAmount: number
    igstAmount: number
    cgstAmount: number
    sgstAmount: number
    totalAmount: number
    unitCost: number
    productName: string
    productCode: string
    modelNumber:string
    productGroupCode: string
    reOrder: number
    gst: string
    sac: number | string
    hsnCode: number | string
    pwoGst: number
    pwGst: number
    wholesaleRate: number
    retailRate: number
    stock: number
    department: string
    category: string
    brand: string
    vendor: string
    updatedByOn: string

}

export enum StockMasterActionsList {
    ADD_STOCKMASTER = 'ADD_STOCKMASTER',
    EDIT_STOCKMASTER = 'EDIT_STOCKMASTER',
    FETCH_STOCKMASTER = 'FETCH_STOCKMASTER',
    DELETE_STOCKMASTER = 'DELETE_STOCKMASTER'
}


export interface FetchStockMasterAction {
    type: StockMasterActionsList.FETCH_STOCKMASTER
    data: StockMasterType[]

}

export interface EditStockMasterAction {
    type: StockMasterActionsList.EDIT_STOCKMASTER;
    data: Partial<StockMasterType>
    id: number | undefined
}

export type StockMasterActions = FetchStockMasterAction | EditStockMasterAction;

export const fetchStockMasterAction = () => {
    return async (dispatch: Dispatch) => {
        const response = await getStockMaster()
        const data = response.data.data?.map((res: any) => {
            let camelCase: Partial<StockMasterType> = {}
            for (let i = 0; i < Object.keys(res).length; i++) {
                const key = camelize(Object.keys(res)[i])
                const value = Object.values(res)[i]
                camelCase = { ...camelCase, [key]: value }
            }
            return camelCase as StockMasterType
        })
        dispatch<FetchStockMasterAction>({
            type: StockMasterActionsList.FETCH_STOCKMASTER,
            data: data
        })
    }
}

export const editStockMasterAction = (data: any, id: number | undefined) => {
    return async (dispatch: Dispatch) => {
        return updateStockMaster(data, id).then(response => {
            if (response.status === 200 && response.data.data) {
                let editData: Partial<StockMasterType> = {}
                for (let i = 0; i < Object.keys(response.data.data).length; i++) {
                    const key = camelize(Object.keys(response.data.data)[i])
                    const value = Object.values(response.data.data)[i]
                    editData = { ...editData, [key]: value }
                }
                dispatch<EditStockMasterAction>({
                    type: StockMasterActionsList.EDIT_STOCKMASTER,
                    data: editData,
                    id: id
                })

                return Promise.resolve(response.data.message
                    ? response.data.message
                    : 'Shop Updated')
            } else {
                throw { response }
            }
        }).catch(error => {
            return Promise.reject(error.response
                ? error.response.data.message
                    ? error.response.data.message
                    : 'Unable to update'
                : 'Unable to update')
        })
    }

}
